import { GET } from 'utils/requests.utils'

const BASE_URL = '/cabinet/content_block_templates/general'

export const fetchList = (data) => GET(BASE_URL, data)
